import expressSATAFront from '@/assets/product_images/2.MRT-SATA-Card-Reverse-Side-1.jpg';
import expressSATAReverse from '@/assets/product_images/1.MRT-SATA-Card.jpg';
import usbTerminal from '@/assets/product_images/4.USB-Terminal-1.jpg';
import comCable from '@/assets/product_images/10.Connector-of-USB-Terminal-Instruction-Head.jpg';
import instructionHeads from '@/assets/product_images/6.-Instruction-Head.jpg';
import programmer from '@/assets/product_images/3.Programmer-1.jpg';
import programmerCable from '@/assets/product_images/9.-Programmer-Cable.jpg';
import powerCables from '@/assets/product_images/11.-HDD-Power-Supply-Cable.jpg';
import sataCables from '@/assets/product_images/8.-SATA-Cable.jpg';
import usbCable from '@/assets/product_images/7.-USB-Cable.jpg';
import hardwareConnection from '@/assets/product_images/hardware-connection.jpg';
import hardwareConnectionInside from '@/assets/product_images/Hardware-Connection-Inside-Computer-.jpg';
import ultraSATAFront from '@/assets/product_images/MRT-Ultra-SATA-Controller-Card-Reverse-Side.jpg';
import ultraSATAReverse from '@/assets/product_images/MRT-Ultra-1.jpg';
import mrtMainInterface from '@/assets/product_images/MRT主界面.jpg';
import mrtCommonToolsModule from '@/assets/product_images/常用工具模块.png';
import mrtDataRecoveryFactory from '@/assets/product_images/数据恢复工具模块(DE).png';
import mrtWesternDigital from '@/assets/product_images/西数模块.png';
import mrtSeagate from '@/assets/product_images/希捷模块.png';
import mrtHitachi from '@/assets/product_images/日立模块.png';
import mrtSamsung from '@/assets/product_images/三星模块.png';
import mrtToshiba from '@/assets/product_images/东芝模块.png';
import mrtMaxtor from '@/assets/product_images/迈拓模块.png';
// SSD模块图片缺失
// 海康威视模块图片缺失

// 硬件规格图片
export const hardwareImages = {
  express: [
    {
      key: 'MRTExpressSATAFront',
      name: 'products.HardwareImages.MRTExpressSATAFront',
      thumbnail: expressSATAFront,
      image: expressSATAFront,
      description: 'products.HardwareImages.MRTExpressSATAFrontDesc'
    },
    {
      key: 'MRTExpressSATABack',
      name: 'products.HardwareImages.MRTExpressSATABack',
      thumbnail: expressSATAReverse,
      image: expressSATAReverse,
      description: 'products.HardwareImages.MRTExpressSATABackDesc'
    },
    {
      key: 'SingleCoreUSBTerminal',
      name: 'products.HardwareImages.SingleCoreUSBTerminal',
      thumbnail: usbTerminal,
      image: usbTerminal,
      description: 'products.HardwareImages.SingleCoreUSBTerminalDesc'
    },
    {
      key: 'COMPortDataCable',
      name: 'products.HardwareImages.COMPortDataCable',
      thumbnail: comCable,
      image: comCable,
      description: 'products.HardwareImages.COMPortDataCableDesc'
    },
    {
      key: 'InstructionHeads',
      name: 'products.HardwareImages.InstructionHeads',
      thumbnail: instructionHeads,
      image: instructionHeads,
      description: 'products.HardwareImages.InstructionHeadsDesc'
    },
    // {
    //   key: 'Programmer',
    //   name: 'products.HardwareImages.Programmer',
    //   thumbnail: programmer,
    //   image: programmer,
    //   description: 'products.HardwareImages.ProgrammerDesc'
    // },
    // {
    //   key: 'ProgrammerCable',
    //   name: 'products.HardwareImages.ProgrammerCable',
    //   thumbnail: programmerCable,
    //   image: programmerCable,
    //   description: 'products.HardwareImages.ProgrammerCableDesc'
    // },
    {
      key: 'PowerCables',
      name: 'products.HardwareImages.PowerCables',
      thumbnail: powerCables,
      image: powerCables,
      description: 'products.HardwareImages.PowerCablesDesc'
    },
    {
      key: 'SATACables',
      name: 'products.HardwareImages.SATACables',
      thumbnail: sataCables,
      image: sataCables,
      description: 'products.HardwareImages.SATACablesDesc'
    },
    {
      key: 'USBDDataCable',
      name: 'products.HardwareImages.USBDDataCable',
      thumbnail: usbCable,
      image: usbCable,
      description: 'products.HardwareImages.USBDDataCableDesc'
    },
    {
      key: 'HardwareConnection',
      name: 'products.HardwareImages.HardwareConnection',
      thumbnail: hardwareConnection,
      image: hardwareConnection
    },
    {
      key: 'HardwareConnectionInside',
      name: 'products.HardwareImages.HardwareConnectionInside',
      thumbnail: hardwareConnectionInside,
      image: hardwareConnectionInside
    }
  ],
  ultra: [
    {
      key: 'MRTUltraSATAFront',
      name: 'products.HardwareImages.MRTUltraSATAFront',
      thumbnail: ultraSATAFront,
      image: ultraSATAFront,
      description: 'products.HardwareImages.MRTUltraSATAFrontDesc'
    },
    {
      key: 'MRTUltraSATABack',
      name: 'products.HardwareImages.MRTUltraSATABack',
      thumbnail: ultraSATAReverse,
      image: ultraSATAReverse,
      description: 'products.HardwareImages.MRTUltraSATABackDesc'
    },
    {
      key: 'SingleCoreUSBTerminal',
      name: 'products.HardwareImages.SingleCoreUSBTerminal',
      thumbnail: usbTerminal,
      image: usbTerminal,
      description: 'products.HardwareImages.SingleCoreUSBTerminalDesc'
    },
    {
      key: 'COMPortDataCable',
      name: 'products.HardwareImages.COMPortDataCable',
      thumbnail: comCable,
      image: comCable,
      description: 'products.HardwareImages.COMPortDataCableDesc'
    },
    {
      key: 'InstructionHeads',
      name: 'products.HardwareImages.InstructionHeads',
      thumbnail: instructionHeads,
      image: instructionHeads,
      description: 'products.HardwareImages.InstructionHeadsDesc'
    },
    // {
    //   key: 'Programmer',
    //   name: 'products.HardwareImages.Programmer',
    //   thumbnail: programmer,
    //   image: programmerCable,
    //   description: 'products.HardwareImages.ProgrammerDesc'
    // },
    // {
    //   key: 'ProgrammerCable',
    //   name: 'products.HardwareImages.ProgrammerCable',
    //   thumbnail: programmerCable,
    //   image: programmerCable,
    //   description: 'products.HardwareImages.ProgrammerCableDesc'
    // },
    {
      key: 'PowerCables',
      name: 'products.HardwareImages.PowerCables',
      thumbnail: powerCables,
      image: powerCables,
      description: 'products.HardwareImages.PowerCablesDesc'
    },
    {
      key: 'SATACables',
      name: 'products.HardwareImages.SATACables',
      thumbnail: sataCables,
      image: sataCables,
      description: 'products.HardwareImages.SATACablesDesc'
    },
    {
      key: 'USBDDataCable',
      name: 'products.HardwareImages.USBDDataCable',
      thumbnail: usbCable,
      image: usbCable,
      description: 'products.HardwareImages.USBDDataCableDesc'
    },
    {
      key: 'HardwareConnection',
      name: 'products.HardwareImages.HardwareConnection',
      thumbnail: hardwareConnection,
      image: hardwareConnection
    },
    {
      key: 'HardwareConnectionInside',
      name: 'products.HardwareImages.HardwareConnectionInside',
      thumbnail: hardwareConnectionInside,
      image: hardwareConnectionInside
    }
  ]
};

// 软件轮播图片
export const softwareImages = [
  mrtMainInterface,
  mrtCommonToolsModule,
  mrtDataRecoveryFactory,
  mrtWesternDigital,
  mrtSeagate,
  mrtHitachi,
  mrtSamsung,
  mrtToshiba,
  mrtMaxtor
];

// 软件功能介绍
export const softwareFeatures = [
  {
    title: 'products.MRTMainInterface',
    description: 'products.MainInterfaceDesc'
  },
  {
    title: 'products.CommonToolsModule',
    description: 'products.CommonToolsDesc'
  },
  {
    title: 'products.DataRecoveryToolModule',
    description: 'products.DataRecoveryDesc'
  },
  {
    title: 'products.WesternDigitalModule',
    description: 'products.WesternDigitalDesc'
  },
  {
    title: 'products.SeagateModule',
    description: 'products.SeagateDesc'
  },
  {
    title: 'products.HitachiModule',
    description: 'products.HitachiDesc'
  },
  {
    title: 'products.ToshibaModule',
    description: 'products.ToshibaDesc'
  },
  {
    title: 'products.MaxtorModule',
    description: 'products.MaxtorDesc'
  },
  {
    title: 'products.SamsungModule',
    description: 'products.SamsungDesc'
  },
  {
    title: 'products.FujitsuModule',
    description: 'products.FujitsuDesc'
  },
  {
    title: 'products.SSDModule',
    description: 'products.SSDDesc'
  },
  {
    title: 'products.MonitoringVideoModule',
    description: 'products.MonitoringVideoDesc'
  }
];

// 产品描述 - 使用模板字符串实现文本中随时换行
export const productDescriptions = {
  express: {
    title: 'products.MRTExpress',
    description: 'products.ExpressDescription',
    overview: 'products.ExpressOverview',
    versions: {
      network: {
        title: 'products.NetworkFullVersion',
        description: 'products.NetworkFullVersionDescExpress'
      },
      standalone: {
        title: 'products.StandaloneFullVersion',
        description: 'products.StandaloneFullVersionDesc'
      },
      repair: {
        title: 'products.StandaloneRepairVersion',
        description: 'products.StandaloneRepairVersionDesc'
      }
    }
  },
  ultra: {
    title: 'products.MRTUltra',
    description: 'products.UltraDescription',
    overview: 'products.UltraOverview',
    versions: {
      network: {
        title: 'products.NetworkFullVersion',
        description: 'products.NetworkFullVersionDescUltra'
      },
      standalone: {
        title: 'products.StandaloneFullVersion',
        description: 'products.StandaloneFullVersionDesc'
      },
      repair: {
        title: 'products.StandaloneRepairVersion',
        description: 'products.StandaloneRepairVersionDesc'
      }
    }
  }
};

// 版本选项
export const versionOptions = [
  { value: 'network', label: 'products.NetworkFullVersion' },
  { value: 'standalone', label: 'products.StandaloneFullVersion' },
  { value: 'repair', label: 'products.StandaloneRepairVersion' }
];

// 默认配置
export const defaultConfig = {
  currentProduct: 'express',
  currentVersion: 'network'
};

// 文本样式配置 - 用于支持文本颜色设置
export const textStyles = {
  primary: 'color: #333;',
  secondary: 'color: #666;',
  highlight: 'color: #009688;', // 使用主题色
  success: 'color: #4caf50;',
  warning: 'color: #ff9800;',
  danger: 'color: #f44336;'
};


// WEBPACK FOOTER //
// ./src/data/productData.js